// extracted by mini-css-extract-plugin
export var explainable = "_ji-a";
export var printerCard = "_ji-1";
export var printerCardConfigured = "_ji-2";
export var printerCardError = "_ji-3";
export var printerCardsContainer = "_ji-0";
export var printerIcon = "_ji-8";
export var printerIconConfigured = "_ji-5";
export var printerIconContainer = "_ji-4";
export var printerIconError = "_ji-6";
export var printerIconUnconfigured = "_ji-7";
export var workstationsTableCard = "_ji-9";